<template>
  <div class="footer-wrap">
    <div class="footer-nav wrap">
      <el-row class="fl">
        <!-- <el-col :span="6">
          <h4>产品展示</h4>
          <ul class="sub-nav">
            <li>
              <el-link type="primary" class="nav-link" href="javascript:alert('敬请期待')">
                寻源云</el-link>
            </li>
            <li>
              <el-link type="primary" class="nav-link" href="javascript:alert('敬请期待')">
                超市云</el-link>
            </li>
            <li>
              <el-link type="primary" class="nav-link" href="javascript:alert('敬请期待')">
                金融云</el-link>
            </li>
            <li>
              <el-link type="primary" class="nav-link" href="javascript:alert('敬请期待')">
                差旅云</el-link>
            </li>
            <li>
              <el-link type="primary" class="nav-link" href="javascript:alert('敬请期待')">
                社区云</el-link>
            </li>
          </ul>
        </el-col> -->
        <el-col :span="6">
          <h4>服务指南</h4>
          <ul class="sub-nav">
            <li>
              <el-link
                type="primary"
                class="nav-link"
                @click="$router.push({name:'operationprocedure'})"
              >
                操作手册</el-link
              >
            </li>
            <li>
              <el-link
                type="primary"
                class="nav-link"
                @click="$router.push({name:'relateddownload'})"
              >
                相关下载</el-link
              >
            </li>
            <li>
              <el-link
                type="primary"
                class="nav-link"
                @click="$router.push({name:'frequencyquestion'})"
              >
                常见问题</el-link
              >
            </li>
          </ul>
        </el-col>
        <el-col :span="6">
          <h4>政策法规</h4>
          <ul class="sub-nav">
            <li>
              <el-link
                type="primary"
                class="nav-link"
                @click="$router.push({name:'nationalpolicy'})"
              >
                国家相关政策</el-link
              >
            </li>
            <li>
              <el-link
                type="primary"
                class="nav-link"
                @click="$router.push({name:'localpolicy'})"
              >
                地方相关政策</el-link
              >
            </li>
            <li>
              <el-link
                type="primary"
                class="nav-link"
                @click="$router.push({name:'platformpolicy'})"
              >
                平台政策</el-link
              >
            </li>
          </ul>
        </el-col>
        <el-col :span="6">
          <h4>关于我们</h4>
          <ul class="sub-nav">
            <li>
              <el-link
                type="primary"
                class="nav-link"
                @click="$router.push({name:'platformintroduction'})"
              >
                平台介绍</el-link>
            </li>
            <li>
              <el-link
                type="primary"
                class="nav-link"
                @click="$router.push({name:'agencyinfo'})"
              >
                代理机构展示</el-link>
            </li>
            <li>
              <el-link
                type="primary"
                class="nav-link"
                @click="$router.push({name:'contactus'})"
              >
                联系我们</el-link
              >
            </li>
            <li>
              <el-link
                type="primary"
                class="nav-link"
                @click="$router.push({name:'complaintAndfeedback'})"
              >
                业务投诉和违纪举报</el-link
              >
            </li>
          </ul>
        </el-col>
      </el-row>
      <div class="company-info fr">
        <div class="info-txt">
          <div>
            <h3>服务热线</h3>
            <h4>022-58101058</h4>
            <div class="pic">
              <img src="@/assets/img/wcode.png" alt />
            </div>
            <div class="code">关注产权公众号，了解相关讯息。</div>
            <!--<div class="info-address">公司地址：山东省济南市高新区。</div>-->
          </div>
        </div>
      </div>
    </div>
    <div id="footer" class="container-fluid">
      <div class="footer-address">
        <div class="address_copy">
          <p class="fl">
            <a
              href="http://beian.miit.gov.cn"
              target="_blank"
              style="color: #ffffff; cursor: pointer; text-decoration: none"
              >津ICP备05010240号</a
            >
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010302001755"
              target="_blank"
              style="color: #ffffff; cursor: pointer; text-decoration: none"
            >
              <img style="display: unset" src="@/assets/img/netsecurity.png" />
              津公网安备 12010302001755号</a
            >
            版权所有 &copy; 天津产权交易中心 2018
          </p>
          <p class="fl">
            <span>咨询投诉热线：022-58101058</span>
            <span>地址：天津市河西区琼州道103-1号</span>
          </p>
        </div>
        <div class="foot-phone">
          <div class="footer-content">天津产权交易中心不作为不担当问题</div>
          <div class="footer-content">监督电话：58922012<br /></div>
          <div class="footer-content">举报电话：58922023</div>
          <img
            style="margin-top: -15px; float: right"
            src="@/assets/img/index_foot_phone.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.footer-wrap {
  background: #fff;
  padding-top: 28px;
  line-height: 30px;
  font-size: 14px;
  color: #999;
  width: 1300px;
  margin: auto;

  .footer-nav {
    overflow: hidden;
    margin: 0 auto;
    width: 1100px;
    .el-row {
      width: 65%;

      h4 {
        font-size: 16px;
        color: #333;
        margin: 0;
      }

      .sub-nav {
        margin-top: 10px;

        li {
          .nav-link {
            font-size: 14px;
            color: #999;
          }

          .nav-link:hover {
            color: #2277e4;
            text-decoration: none;
          }
        }
      }
    }

    .company-info {
      width: 30%;

      .info-txt {
        overflow: hidden;

        h3 {
          margin: 0;
          margin-bottom: 4px;
          font-weight: 600;
          font-size: 16px;
          color: #388fff;
        }

        h4 {
          margin: 0;
          font-weight: 600;
          font-size: 18px;
          color: #388fff;
        }

        h5 {
          font-size: 14px;
          color: #999;
          margin: 0;
        }

        .pic {
          width: 100%;
          text-align: center;
          float: left;

          img {
            display: block;
            margin: 0 auto;
            width: 95px;
            height: 95px;
            float: left;
          }

          .code {
            font-size: 14px;
            color: #999;
          }
        }
      }

      .info-address {
        line-height: 18px;
        font-size: 14px;
        color: #000;
        margin-top: 7px;
      }
    }
  }

  .footer-copyright {
    margin-top: 28px;
    border-top: 1px solid #e9e9e9;
    overflow: hidden;

    .info {
      margin: 9px auto 10px;
      width: 1200px;
      font-size: 14px;
      color: #999;
    }

    img {
      margin-right: 10px;
      width: 24px;
      height: 24px;
      vertical-align: middle;
    }

    span {
      margin-right: 10px;
    }
  }
}
.el-col-6 {
  float: left;
  width: 20%;
}
.el-row {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(16, 65, 102, 1);
  overflow: hidden;
  text-align: center;
  margin-top: 40px;
  border-top: 1px solid #e9e9e9;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.footer-address {
  width: 1300px;
  margin: auto;
}
.address_copy {
  font-size: 14px;
  margin: 10px 110px 10px 50px;
  float: left;
  width: 740px;
  height: 100px;
}
.foot-phone {
  width: 247px;
  height: 100px;
  margin: 10px 800px 10px 990px;
  border: 2px solid;
  border-color: #ffffff;
  position: absolute;
}
.footer-content {
  margin-left: 10px;
  float: left;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue